// extracted by mini-css-extract-plugin
export var container = "_g9-0";
export var infoIcon = "_g9-2";
export var titleRowCol = "_g9-1";